<template>
  <v-card class="new-child-component">
    <section
      :style="{ backgroundColor: background }"
      class="layout align-center justify-center column name"
    >
      <h5>{{ firstName }}</h5>
    </section>
    <v-card-text>
      <h4>Add a new child</h4>
      <v-text-field
        class="mt-2"
        v-model="firstName"
        v-validate="'required|max:150'"
        label="First Name"
        data-vv-name="first_name"
        data-vv-as="first name"
        required
        :error-messages="errors.collect('first_name')"
      />
      <v-btn
        block
        color="primary"
        outlined
        @click="save"
        :loading="loading"
        :disabled="loading"
        class="mt-3"
      >
        save
      </v-btn>
      <v-btn block color="error" class="mt-2" outlined @click="cancel">
        cancel
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Parent from '@/modules/parent/models/Parent'

export default {
  name: 'NewChild',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      loading: false,
      firstName: '',
      backgroundColors: [
        '#F44336',
        '#FF4081',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#03A9F4',
        '#00BCD4',
        '#009688',
        '#4CAF50',
        '#8BC34A',
        '#CDDC39',
        /* '#FFEB3B' , */ '#FFC107',
        '#FF9800',
        '#FF5722',
        '#795548',
        '#9E9E9E',
        '#607D8B'
      ]
    }
  },
  computed: {
    background() {
      return this.randomBackgroundColor(
        this.firstName.length,
        this.backgroundColors
      )
    }
  },
  methods: {
    randomBackgroundColor(seed, colors) {
      return colors[seed % colors.length]
    },
    async save() {
      let result = await this.$validator.validateAll()
      if (!result) return
      this.loading = true
      await Parent.dispatch('createChild', this.firstName)
      await Parent.dispatch('getChildren')
      this.firstName = ''
      this.loading = false
      this.$emit('update:newChild', false)
    },
    cancel() {
      this.$emit('update:newChild', false)
    }
  }
}
</script>

<style lang="scss">
.new-child-component {
  min-height: 445px;
  .name {
    height: 200px;

    h5 {
      font-size: 3em;
      text-transform: capitalize;
      color: white;
    }
  }
  h4 {
    font-size: 1.8em;
  }
}
</style>
